<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
    <div class="row">
      <div class="col-12"></div>
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <!-- ngx-datatable-filter -->
              <fieldset class="form-group">
                <div class="row align-items-end mt-0 pagination-body">
  
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-2">
                    <div class="btn-group enrollment-list-btn-info" role="group">
                      <button class="btn enrollment-list-buttons cursor-pointer" type="button" *ngFor="let status of status_list"
                        [ngClass]="{'btn-primary':activeTab==status?.name,'btn-outline-primary':activeTab!=status?.name}"
                        (click)="activeEmployeeTab(status?.name,0)">{{status.displayname}}</button>
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                    <div class="row-flex">
                     
                      <div class="col-flex-2 mb-1 position-relative" placement="top"
                        ngbTooltip="search by  name,email,phone,pan,account number,empcode">
                        <input id="ngx-filter-ref"
                          class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                          type="text" placeholder="Search" #name [(ngModel)]="searchVal"
                           />
                        <button class="btn search-btn glow position-absolute" >
                          <i class="ft-search text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1">
                        <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">
                          Reset
                          <i class="ft-filter text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1"
                        *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                        <button type="button" class="btn btn-primary btn-block users-list-clear glow mb-0"
                          routerLink="/openings/add" placement="top" ngbTooltip="Add New">
                          +
                        </button>
                      </div>
  
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 pagination-body header-body mb-2">
                    <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                      [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                      [count]="page.totalPages" [offset]="page.pageNumber" (page)="pageChangeData($event)">
                      <ngx-datatable-footer>
                        <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize">
                          <div class="datatable-footer-inner">
                            <div class="total-count">
                              <span>Total : {{page.totalPages}} </span>
                            </div>
                          </div>
                        </ng-template>
                      </ngx-datatable-footer>
  
                    </ngx-datatable>
                  </div>
                  <div class="col">
                    <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Opening Guideline</button>
                  </div>
                </div>
              </fieldset>
              <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
                [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
                [columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.pageNumber"
                (page)="pageChangeData($event)">
                <ngx-datatable-column name="Title" prop="title" [width]="180">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex align-items-center">
                      <!-- <img
                        class="rounded-circle mr-1"
                        *ngIf="row.image"
                        [src]="imageUrl + row.image"
                        height="32"
                        width="32"
                      /> -->
                      <div *ngIf="!row.image" class="avatar mr-1 ml-0 bg-primary">
                        <div class="avatar-content">
                          {{ row?.title | shortName }}
                        </div>
                      </div>
  
                      <!-- <div class="cell-line-height">
                        <a
                          class="line-height-1 mb-0"
                          [routerLink]="['/tags/tag-view', row._id]"
                          (click)="editTag(row._id)"
                          >{{ row.tagName }}</a
                        >
                      </div> -->
                      <div class="cell-line-height cursor-pointer" >
                        <p class="font-medium-1 line-height-1 mb-0">
                          {{ row?.title }}
                        </p>
                        <span class="text-muted font-small-2">
                          <!-- {{ row?.tagcategories_ids[0]?.name }} -->
                        </span>
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Company" prop="company" [width]="70">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="cell-line-height">
                      {{ row?.company?.name }}
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Category" prop="category" [width]="30">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="cell-line-height">
                      {{ row?.category?.displayname }}
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Employment Type" prop="employment_type" [width]="70">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="cell-line-height">
                      {{ row?.employment_type?.displayname }}
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Applied For" prop="applied_for" [width]="70">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div *ngIf="row?.applied_for.length==0">
                      <i class="ft-plus text-primary cursor-pointer mr-2" (click)="openModal(modal,'applied_for',row?._id,'null')"></i>
                    </div>
                    <div *ngIf="row?.applied_for.length>0">
                      <span *ngFor="let user of row?.applied_for ; let i=index">
                        <span class="badge badge-pill bg-light-primary mr-1 mb-1" *ngIf="i < 3" (click)="openModal(modal,'applied_for',row?._id,row?.applied_for)">{{user.name}}</span>
                      </span>
                    </div>
                    <span class="badge badge-pill ml-1" *ngIf="row?.applied_for?.length > 3">+  {{row?.applied_for?.length - 3}} more</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Short Listed" prop="sort_listed" [width]="70">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div *ngIf="row?.sort_listed.length==0">
                      <i class="ft-plus text-primary cursor-pointer mr-2" (click)="openModal(modal,'sort_listed',row?._id,'null')"></i>
                    </div>
                    <div *ngIf="row?.sort_listed.length>0">
                      <span *ngFor="let user of row?.sort_listed ; let i=index">
                        <span class="badge badge-pill bg-light-primary mr-1 mb-1" *ngIf="i < 3" (click)="openModal(modal,'sort_listed',row?._id,row?.sort_listed)">{{user.name}}</span>
                      </span>
                    </div>
                    <span class="badge badge-pill ml-1" *ngIf="row?.sort_listed?.length > 3">+  {{row?.sort_listed?.length - 3}} more</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Actions" [width]="50"
                  *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <i mat-button="mat-button" [matMenuTriggerFor]="menu" class="ft-more-vertical text-primary cursor-pointer mr-2"></i>
                    <i mat-button="mat-button" [matMenuTriggerFor]="menu2" class="ft-settings text-primary cursor-pointer mr-2"></i>
                    <!-- <i class="ft-edit text-primary cursor-pointer mr-2" [routerLink]="['/openings/edit', row._id]"
                      ></i>
                    <i *ngIf="user_role.roles =='admin'" class="ft-trash-2 cursor-pointer danger"
                      (click)="ConfirmColor(row._id)"></i> -->

                    <mat-menu #menu="matMenu">
                        <div class="menu-box">
                        <div *ngFor="let status of status_list">
                        <span class="mb-1 cursor-pointer" [ngClass]="{'badge badge-pill bg-light-success': status.displayname == 'Open' }" *ngIf="status.name != activeTab && status.displayname == 'Open'" (click)="updateStatus(status?._id,row?._id)">{{status.displayname}}</span>

                        <span class="mb-1 cursor-pointer" [ngClass]="{'badge badge-pill bg-light-warning': status.displayname == 'Closed' }" *ngIf="status.name != activeTab && status.displayname == 'Closed'" (click)="updateStatus(status?._id,row?._id)">{{status.displayname}}</span>

                        <span class="mb-1 cursor-pointer" [ngClass]="{'badge badge-pill bg-light-danger': status.displayname == 'Expired' }" *ngIf="status.name != activeTab && status.displayname == 'Expired'" (click)="updateStatus(status?._id,row?._id)">{{status.displayname}}</span>

                        <span class="mb-1 cursor-pointer" [ngClass]="{'badge badge-pill bg-light-info': status.displayname == 'General' }" *ngIf="status.name != activeTab && status.displayname == 'General'" (click)="updateStatus(status?._id,row?._id)">{{status.displayname}}</span>
                        </div>
                        </div>
                    </mat-menu>
                    <mat-menu #menu2="matMenu">
                      <div  class="menu-box">
                        <button class="btn" [routerLink]="['/openings/edit', row._id]">Edit</button>
                        <!-- <button class="btn" (click)="openInNewTab(row._id)">Applied For</button>
                        <button class="btn" (click)="openInNewTab(row._id)">Short Listed</button> -->
                        <button *ngIf="user_role.roles =='admin'" class="btn bg-light-danger" (click)="ConfirmColor(row._id)">Delete</button>
                        <button *ngIf="user_role.roles =='admin' && activeTab =='general' " class="btn bg-light-primary" (click)="copyRow(row)">copy</button>
                      </div>
                    </mat-menu>


                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <!-- ngx-datatable-filter -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--/ Filter Datatables -->
  <div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
  </div>

<!-- ------ Add Applied For And Short Listed -------------------- -->

<div>
  <ng-template #modal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" *ngIf="!isUpdate">Add</h4>
      <h4 class="modal-title" *ngIf="isUpdate">Update</h4>

      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div *ngIf="isAppliedFor">
        <label> Applied For</label>
        <ng-select
            [items]="users_list"
            bindLabel="name"
            bindValue="_id"
            placeholder="Select Candidate"
            [multiple]="true"
            [(ngModel)]="selected_user"
            [ngModelOptions]="{ standalone: true }" [appendTo]="'body'" [virtualScroll]="true" [clearSearchOnAdd]="true"
            (change)="getUserId($event)"
        >
        </ng-select>
      </div>     
      <div *ngIf="!isAppliedFor">
        <label> Short Listed</label>
        <ng-select
        [items]="users_list"
        bindLabel="name"
        bindValue="_id"
        placeholder="Select Candidate"
        [multiple]="true"
        [(ngModel)]="selected_shortlist_user"
        [ngModelOptions]="{ standalone: true }" [appendTo]="'body'" [virtualScroll]="true" [clearSearchOnAdd]="true"
        (change)="getShortUserId($event)"
        >
        </ng-select>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="add()">Submit</button>
    </div>
  </ng-template>
</div>

